var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 38,
    viewBox: "0 0 50 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_379_32565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H50V37.5H0V0Z",
    fill: "#DE2910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00009 13.875L9.37505 3.75L12.75 13.875L3.75012 7.6875H15L6.00009 13.875Z",
    fill: "#FFDE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6383 3.94403L17.1651 4.71373L19.4819 2.01399L19.2546 5.64749L17.3272 2.43075L20.6383 3.94403Z",
    fill: "#FFDE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1437 8.38651L20.6438 7.74888L23.8263 6.15901L22.2077 9.41997L21.6787 5.70748L24.1437 8.38651Z",
    fill: "#FFDE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6329 14.6191L20.6973 12.6094L24.2515 12.4558L21.4437 14.7731L22.4748 11.1676L23.6329 14.6191Z",
    fill: "#FFDE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2179 18.6907L17.2863 15.7032L20.624 16.9342L17.1391 17.9872L19.4827 15.0597L19.2179 18.6907Z",
    fill: "#FFDE00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_379_32565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 37.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/cn.4a8064989c7d0d0690bd51fd87aac528.svg";
export { ForwardRef as ReactComponent };